import React from "react";
import PropTypes from "prop-types";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";

import _ from "lodash";

function TrajectorySelector(props) {
  const {
    classes,
    trajectories,
    findAndSetTrajectory,
    trajectorySelection,
    queryTrajectory
  } = props;

  const phiValues = _.sortBy(_.uniq(_.map(trajectories, "PHI")));
  const chiValues = _.sortBy(_.uniq(_.map(trajectories, "CHI")));
  const versionValues = _.sortBy(_.uniq(_.map(trajectories, "version")));

  const [phi, setPhi] = React.useState(
    trajectorySelection ? trajectorySelection.PHI : phiValues[0]
  );
  const [chi, setChi] = React.useState(
    trajectorySelection ? trajectorySelection.CHI : chiValues[0]
  );
  const [version, setVersion] = React.useState(
    trajectorySelection ? trajectorySelection.version : versionValues[0]
  );

  const selectPhiChange = event => {
    setPhi(event.target.value);
  };

  const selectChiChange = event => {
    setChi(event.target.value);
  };

  const selectVersionChange = event => {
    setVersion(event.target.value);
  };

  React.useEffect(() => {
    findAndSetTrajectory(phi, chi, version);
  }, [phi, chi, version, findAndSetTrajectory]);

  return (
    <Toolbar style={{ height: "90px" }}>
      <Grid container alignItems="center">
        <Grid item xs>
          <InputLabel id="phi-select-label">PHI</InputLabel>
          <Select
            labelId="phi-select-label"
            id="phi-select"
            value={phi}
            onChange={selectPhiChange}
          >
            {phiValues.map(phiVal => {
              return (
                <MenuItem key={phiVal} value={phiVal}>
                  {phiVal}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        <Grid item xs>
          <InputLabel id="chi-select-label">CHI</InputLabel>
          <Select
            labelId="chi-select-label"
            id="chi-select"
            value={chi}
            onChange={selectChiChange}
          >
            {chiValues.map(chiVal => {
              return (
                <MenuItem key={chiVal} value={chiVal}>
                  {chiVal}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        <Grid item xs>
          <InputLabel id="version-select-label">Version</InputLabel>
          <Select
            labelId="version-select-label"
            id="version-select"
            value={version}
            onChange={selectVersionChange}
          >
            {versionValues.map(versionVal => {
              return (
                <MenuItem key={versionVal} value={versionVal}>
                  {versionVal}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        <Grid item xs>
          <InputLabel>Count</InputLabel>
          {trajectorySelection && (
            <TextField
              value={trajectorySelection.count}
              disabled={true}
              InputProps={{
                disableUnderline: true,
                className: classes.searchInput
              }}
            />
          )}
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.addUser}
            onClick={queryTrajectory}
          >
            Fetch
          </Button>
        </Grid>
      </Grid>
    </Toolbar>
  );
}

TrajectorySelector.propTypes = {
  classes: PropTypes.object.isRequired
};

export default TrajectorySelector;



// WEBPACK FOOTER //
// ./src/sections/data/components/TrajectorySelector.js